import { ListFullTagsResponse } from '@eigtech/resource-tagging-types'
import { Column, DataGridArrayFilter, FilterFnOption } from '@eigtech/ui-shared-data-grid'
import { mapKeys } from 'lodash-es'
import { JSX } from 'react'

export const tagFilterFns = {
  tagIncludesKey: (tags: ListFullTagsResponse | undefined, filterValues: string[]) =>
    tags?.some((tag) =>
      typeof tag === 'string'
        ? filterValues.some((filter) => filter === tag)
        : filterValues.some((filter) => filter === tag.key)
    ) ?? false,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
} satisfies Record<string, Function>

export const tagFilterLabels: Record<TagFilterFn, (keys: string[]) => string> = {
  tagIncludesKey: (keys: string[]) => `includes "${keys.join(' or ')}"`,
}

export type TagFilterFn = keyof typeof tagFilterFns

const filterDict: Record<TagFilterFn, string> = {
  tagIncludesKey: 'tagIncludesKey',
}

const filterNameDict = mapKeys(filterDict, (key) => tagFilterFns[key as TagFilterFn].name)

export const getTagFilterActualName = (filterName: string | FilterFnOption<unknown>) =>
  (typeof filterName === 'function'
    ? filterName.name
    : (filterNameDict[filterName] ?? filterName)) as TagFilterFn

export function getTagFilterFnComponent<TData, TValue>({
  column,
}: {
  column: Column<TData, TValue>
}) {
  const filterName = column.getFilterFn()?.name ?? ''

  const notImplemented = <span>Filter not implemented for: {filterName}</span>

  const components: Record<TagFilterFn, JSX.Element> = {
    tagIncludesKey: <DataGridArrayFilter column={column} type="some" />,
  }

  const filterActualName = getTagFilterActualName(filterName)

  return components[filterActualName] ?? notImplemented
}
